import useAppStoreContext from "../context/app-store/app-store.context";
import IException from "../contracts/IException";

/** 
 * NOTE         : reject handler is for networking and CORS errors
 */
function useApi() {

  // #region Constants
  const { accessToken, tenantCode } = useAppStoreContext();

  //TODO : need to replace usage of this variable TENANT_ID with the one passed from RMS site.
  //Till then taking the value from env file
  const TENANT_ID: string = tenantCode || `${process.env.REACT_APP_TENANT_CODE}`;

  const DEFAULT_HEADERS = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
    "Content-Type": "application/json",
    "Authorization": `Bearer ${accessToken}`
  };

  const ALL_REPORTS_EP: string = 'AllReports';
  const SELECTED_COLUMNS_EP: string = 'SelectedColumns';
  const AVAILABLE_COLUMNS_EP: string = 'AvailableColumns';
  const DEFAULT_FILTERS_EP: string = 'FilterCriteria';
  const REPORT_DATA_EP: string = 'ReportData';
  const SAVE_SELECTED_COLUMNS_EP: string = 'SaveSelectedColumns';
  const SAVE_FILTERS_EP: string = 'SaveFilterCriteria';
  const DATASOURCES_EP: string = 'ReportDataSources';
  const SAVE_REPORT_DATA_EP: string = 'CreateReport';

  const FILTER_OPTIONS_EP: string = 'FilterOptions';
  const GROUP_BY_OPTIONS_EP: string = 'GroupByOptions';
  const FORMAT_OPTIONS_EP: string = 'FormatOptions';

  const REPORT_DETAILS_EP: string = 'Report/ReportDetails';


  // REST-VERBS

  const GET = async <R>(endpoint: string,
    doBeforePromise: () => void,
    onFulfilled: (result: R) => void,
    onRejection: (rejection: IException) => void,
    onException: (exception: IException) => void,
    doAfterPromise: () => void
  ) => {

    doBeforePromise();


    return fetch(endpoint,
      {
        method: "GET",
        headers: DEFAULT_HEADERS
      })
      .then(async (response) => {
        await validateResponse(response, onFulfilled, doAfterPromise);
      },
        (rejection) => handleRejection(rejection, doAfterPromise, onRejection))
      .catch(exception => handleException(exception, doAfterPromise, onException));
  }

  const POST = async <B, R>(endpoint: string, body: B,
    doBeforePromise: () => void,
    onFulfilled: (result: R) => void,
    onRejection: (rejection: IException) => void,
    onException: (exception: IException) => void,
    doAfterPromise: () => void
  ) => {

    doBeforePromise();

    return fetch(endpoint,
      {
        method: "POST",
        headers: DEFAULT_HEADERS,
        body: JSON.stringify(body)
      })
      .then(async (response) => {
        await validateResponse(response, onFulfilled, doAfterPromise);
      },
        (rejection) => handleRejection(rejection, doAfterPromise, onRejection))
      .catch(exception => handleException(exception, doAfterPromise, onException));
  }

  const DELETE = async <R>(
    endpoint: string,
    doBeforePromise: () => void,
    onFulfilled: (result: R) => void,
    onRejection: (rejection: IException) => void,
    onException: (exception: IException) => void,
    doAfterPromise: () => void
  ) => {
    doBeforePromise();

    return fetch(endpoint, {
      method: 'DELETE',
      headers: DEFAULT_HEADERS
    })
      .then(async (response) => {
        await validateResponse(response, onFulfilled, doAfterPromise);
      })
      .catch(exception => {
        console.log('Exception in DELETE request:', exception);
        handleException(exception, doAfterPromise, onException)
      });
  };


  const PUT = async <R>(
    endpoint: string,
    doBeforePromise: () => void,
    onFulfilled: (result: R) => void,
    onRejection: (rejection: IException) => void,
    onException: (exception: IException) => void,
    doAfterPromise: () => void
  ) => {
    doBeforePromise();

    return fetch(endpoint, {
      method: 'PUT',
      headers: DEFAULT_HEADERS
    })
      .then(async (response) => {
        await validateResponse(response, onFulfilled, doAfterPromise);
      })
      .catch(exception => {
        console.log('Exception in PUT request:', exception);
        handleException(exception, doAfterPromise, onException)
      });
  };

  // #endregion


  const validateResponse = async<R>(
    response: Response,
    onFulfilled: (result: R) => void,
    doAfterPromise: () => void,
  ) => {
    if (response.ok) {
      let json = await response.json();
      onFulfilled(json as R);
      doAfterPromise();
    } else {
      throw new Error(response.status + " - " + response.statusText, { cause: response });
    }
  }


  const handleRejection = (
    rejection: any, doAfterPromise: () => void,
    onRejection: (rejection: IException) => void
  ) => {
    onRejection({
      code: '',
      title: 'rejected',
      message: 'possibly network/CORS issue',
      exception: rejection
    });
    doAfterPromise();
  }

  const handleException = (
    exception: Error, doAfterPromise: () => void,
    onException: (exception: IException) => void
  ) => {
    console.log('exception', exception);
    onException({
      code: '',
      title: exception.name,
      message: exception.message,
      exception: exception
    });
    doAfterPromise();
  }

  //#endregion

  return {

    // REST-VERBS
    GET, POST, DELETE, PUT,

    // CONSTANTS
    TENANT_ID, ALL_REPORTS_EP, REPORT_DATA_EP,
    SELECTED_COLUMNS_EP, AVAILABLE_COLUMNS_EP,
    DEFAULT_FILTERS_EP,
    SAVE_SELECTED_COLUMNS_EP, SAVE_FILTERS_EP, DATASOURCES_EP,
    SAVE_REPORT_DATA_EP,
    FILTER_OPTIONS_EP, GROUP_BY_OPTIONS_EP, FORMAT_OPTIONS_EP,
    REPORT_DETAILS_EP
  };

}
export default useApi;